import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Copy, Gift } from "lucide-react";

export default function ClientReferrals() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/client/referrals").then((r) => setData(r.data)).catch(() => setData({ referrals: [] }));
  }, []);

  const code = data?.referral_code || "";
  const link = code ? `${window.location.origin}/register?ref=${code}` : "";
  const copy = (text, label) => {
    if (!text) return;
    navigator.clipboard.writeText(text).then(() => toast.success(`${label} copiado`)).catch(() => {});
  };

  return (
    <div data-testid="client-referrals-page">
      <div className="cp-page-head">
        <span className="cp-eyebrow">Convidados</span>
        <h1 className="cp-title">
          Convide, <span className="accent">ganhe cashback</span>
        </h1>
        <p className="cp-desc">
          Partilhe o seu código único e ganhe <strong style={{ color: "#f59e0b" }}>{data?.referral_cashback_pct || 5}%</strong> de cashback em cada reserva paga pelos seus convidados. Sem limite, para sempre.
        </p>
      </div>

      <div className="cp-grid cp-grid--2" style={{ marginBottom: 32 }}>
        <div className="cp-ref-hero" style={{ gridColumn: "span 1" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <Gift size={18} style={{ color: "#f59e0b" }} />
            <span className="cp-eyebrow" style={{ marginBottom: 0 }}>O seu código</span>
          </div>
          <div className="cp-ref-code" data-testid="referral-code-big">{code || "…"}</div>
          <div style={{ display: "grid", gap: 10 }}>
            <div className="cp-copy-row">
              <span className="cp-copy-row__label">Código</span>
              <span className="cp-copy-row__value">{code || "—"}</span>
              <button onClick={() => copy(code, "Código")} className="cp-copy-row__btn" data-testid="copy-code">
                <Copy size={12} /> Copiar
              </button>
            </div>
            <div className="cp-copy-row">
              <span className="cp-copy-row__label">Link</span>
              <span className="cp-copy-row__value">{link || "—"}</span>
              <button onClick={() => copy(link, "Link")} className="cp-copy-row__btn" data-testid="copy-link">
                <Copy size={12} /> Copiar
              </button>
            </div>
          </div>
        </div>

        <div className="cp-card">
          <span className="cp-card__label">Saldo cashback</span>
          <div className="cp-card__value" style={{ color: "#f59e0b", marginTop: 12 }} data-testid="cashback-balance">
            €{(data?.cashback_balance || 0).toFixed(2)}
          </div>
          <div className="cp-card__sub">Aplicado automaticamente na próxima reserva.</div>
          <div style={{ marginTop: 24, paddingTop: 20, borderTop: "1px solid rgba(245,240,230,0.14)" }}>
            <span className="cp-card__label">Como funciona</span>
            <ol style={{ color: "#f5f0e6", fontSize: "0.85rem", marginTop: 10, paddingLeft: 20, lineHeight: 1.7 }}>
              <li>Partilha o seu código com amigos</li>
              <li>Amigo regista-se com o seu código</li>
              <li>Ganha 5% cada vez que ele reserva</li>
            </ol>
          </div>
        </div>
      </div>

      <div className="cp-card cp-card--flat">
        <div style={{ padding: "16px 20px", borderBottom: "1px solid rgba(245,240,230,0.14)" }}>
          <span className="cp-card__label">
            Amigos convidados ({data?.referrals?.length || 0})
          </span>
        </div>
        {(!data || !data.referrals || data.referrals.length === 0) ? (
          <div className="cp-empty">Ainda não convidou ninguém. Partilhe o seu código para começar!</div>
        ) : (
          <table className="cp-table">
            <thead>
              <tr>
                <th>Nome</th>
                <th>Email</th>
                <th>Registado em</th>
                <th style={{ textAlign: "right" }}>Total gasto</th>
                <th style={{ textAlign: "right" }}>Cashback</th>
              </tr>
            </thead>
            <tbody>
              {data.referrals.map((r) => (
                <tr key={r.id} data-testid={`referral-${r.id}`}>
                  <td style={{ color: "#f5f0e6", fontWeight: 600 }}>{r.name}</td>
                  <td style={{ color: "#94a3b8", fontSize: "0.82rem" }}>{r.email}</td>
                  <td style={{ color: "#94a3b8", fontSize: "0.82rem" }}>
                    {r.created_at ? new Date(r.created_at).toLocaleDateString() : "—"}
                  </td>
                  <td className="cp-table__amount">€{(r.paid_total || 0).toFixed(2)}</td>
                  <td className="cp-table__amount" style={{ color: "#f59e0b", fontWeight: 700 }}>
                    €{(r.cashback_earned || 0).toFixed(2)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
